var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimePositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 .02)",
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 13.714,
    rx: 10.5,
    ry: 10.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.107 13.714h-1.59m-14.097 0H1.83m8.67-8.571v1.59m.063 13.838v1.59M10.5.857v2.484M8.75.857h3.637m-2.074 7.944v4.944H5.24"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 10.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#39B54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 7.5 2.445 2.445m.055-.055L11.14 5",
    stroke: "#FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePositive);
export default __webpack_public_path__ + "static/media/time-positive.1b1f03d4cb20269e5a924a3e64eac028.svg";
export { ForwardRef as ReactComponent };